module.exports = __webpack_public_path__ + "img/115-c94aef.png";